<template>
  <div class="programs-partnerships-form text-start">
    <v-form>
      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('logistic_operator.label') }}
        </label>
        <v-textarea
          v-model="questions.question1"
          flat
          background-color="field_register"
          class="input-register mt-4"
          :label="mountTranslate('logistic_operator.placeholder')"
          solo
        />
      </div>

      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('is_part_of.label') }}
        </label>
        <v-radio-group
          v-model="questions.question2.hasLogisticOperator"
          class="radio-company"
        >
          <v-radio
            class="mb-5"
            :label="mountTranslate('is_part_of.select_1')"
            :value="mountTranslate('is_part_of.select_1')"
          />
          <v-radio
            class="mb-5"
            :label="mountTranslate('is_part_of.select_2')"
            :value="mountTranslate('is_part_of.select_2')"
          />
          <v-radio
            class="mb-5"
            :label="mountTranslate('is_part_of.select_3')"
            :value="mountTranslate('is_part_of.select_3')"
          />
          <v-radio
            class="mb-5"
            :label="mountTranslate('is_part_of.select_4')"
            :value="mountTranslate('is_part_of.select_4')"
          />
          <v-radio
            :label="mountTranslate('is_part_of.select_5')"
            :value="mountTranslate('is_part_of.select_5')"
          />
          <v-text-field
            v-if="questions.question2.hasLogisticOperator === mountTranslate('is_part_of.select_5')"
            v-model="questions.question2.other"
            flat
            background-color="field_register"
            class="input-register mt-4"
            :label="mountTranslate('is_part_of.placeholder')"
            solo
          />
        </v-radio-group>
      </div>

      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('ong.label') }}
        </label>
        <v-textarea
          v-model="questions.question3"
          flat
          background-color="field_register"
          class="input-register mt-4"
          :label="mountTranslate('ong.placeholder')"
          solo
        />
      </div>

      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('financial_support.label') }}
        </label>
        <v-textarea
          v-model="questions.question4"
          flat
          background-color="field_register"
          class="input-register mt-4"
          :label="mountTranslate('financial_support.placeholder')"
          solo
        />
      </div>

      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('city_hall_support.label') }}
        </label>
        <v-textarea
          v-model="questions.question5"
          flat
          background-color="field_register"
          class="input-register mt-4"
          :label="mountTranslate('city_hall_support.placeholder')"
          solo
        />
      </div>

      <div class="button-access">
        <rectoplus-button
          class="next-button"
          :text="$t('components.register.business.organization.button')"
          @click="nextStep"
        />
      </div>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import RectoplusButton from '@/components/buttons/RectoplusButton.vue';

export default {
  name: 'FormProgramsPartnerships',
  components: {
    RectoplusButton,
  },
  data() {
    return {
      questions: {
        question1: '',
        question2: {
          hasLogisticOperator: '',
          other: '',
        },
        question3: '',
        question4: '',
        question5: '',
      },
    };
  },
  computed: {
    ...mapGetters(['getProgramsPartnerships', 'hasOperationalCapacity']),
  },
  mounted() {
    if (this.hasOperationalCapacity) this.setQuestions();
  },
  methods: {
    ...mapActions([
      'nextSubStep',
      'setQuestionProgramsPartnerships',
    ]),
    mountTranslate(path) {
      return this.$t(`components.stepper_business.sub_steps.programs_partnerships.form.${path}`);
    },
    nextStep() {
      this.setQuestionProgramsPartnerships(this.questions);
      this.nextSubStep();
    },
    setQuestions() {
      Object.keys(this.questions).forEach((key) => {
        this.questions[key] = this.getProgramsPartnerships[key];
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .programs-partnerships-form {
    color: $color_field_quiz;
    font-size: 0.875em;

    .radio-default {
      font-weight: bold;
    }
    .content-field {
      margin-bottom: 20px;
    }
    .title-field {
      font-size: 1.25em;
      font-weight: 600;
    }
    .button-access {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 40px;
      .next-button {
        width: 100%;
        height: 70px;
        margin-bottom: 20px;
      }
    }
    .input-register{
      border-radius: 8px;
    }
  }
</style>
